import { Component } from '@theme/component';

class RhmTextRevealComponent extends Component {
  #ctx: any = null;
  #alive = false;

  connectedCallback() {
    super.connectedCallback();
    if (this.#alive) return;
    this.#init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    queueMicrotask(() => {
      if (this.isConnected) return;
      this.#cleanup();
    });
  }

  #cleanup() {
    this.#alive = false;
    const ST = (window as any).ScrollTrigger;
    if (ST) {
      ST.getAll().forEach((st: any) => {
        if (st.vars?.trigger === this || st.trigger === this) {
          st.kill(false);
        }
      });
    }
    this.#ctx?.revert();
    this.#ctx = null;
  }

  #init() {
    const g = (window as any).gsap;
    const ST = (window as any).ScrollTrigger;
    const SplitText = (window as any).SplitText;
    if (!g || !ST || !SplitText) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.#alive = true;

    const content = this.refs.content as HTMLElement | undefined;
    if (!content) return;

    this.#ctx = g.context(() => {
      const targets = content.querySelectorAll(
        'p, h1, h2, h3, h4, h5, h6, li, span, .rte > *'
      );

      if (targets.length === 0) return;

      const splits: any[] = [];
      targets.forEach((el: Element) => {
        splits.push(
          new SplitText(el, {
            type: 'words',
            wordsClass: 'rhm-text-reveal__word',
          })
        );
      });

      const allWords = splits.flatMap((s: any) => s.words);
      if (allWords.length === 0) return;

      const baseOpacity = parseFloat(this.dataset.baseOpacity || '0.5');
      const pinScroll = this.dataset.pinScroll === 'true';

      g.set(allWords, { opacity: baseOpacity });

      const stConfig: Record<string, any> = {
        trigger: this,
        scrub: true,
      };

      if (pinScroll) {
        stConfig.pin = true;
        stConfig.start = 'top top';
        stConfig.end = () => `+=${window.innerHeight * 2}`;
      } else {
        stConfig.start = 'top 85%';
        stConfig.end = 'bottom 25%';
      }

      g.to(allWords, {
        opacity: 1,
        stagger: 0.05,
        ease: 'none',
        scrollTrigger: stConfig,
      });
    }, this);
  }
}

if (!customElements.get('rhm-text-reveal-component')) {
  customElements.define('rhm-text-reveal-component', RhmTextRevealComponent);
}
